import { get, post } from "./_client";

export type TierInfo = { tier: string; name: string; userCount: number };

export type SubscriptionDetails = {
  status: "none" | "active" | "pending" | "cancelled" | "past_due";
  seats: number;
  tier: string;
  currentPeriodStart: string | null;
  currentPeriodEnd: string | null;
  cancelAtPeriodEnd: boolean;
  paymentMethod: string | null;
  cardBrand: string | null;
  cardLast4: string | null;
  cardExpiry: string | null;
  mollieCustomerId: string | null;
  mollieSubscriptionId: string | null;
};

export type PaymentRecord = {
  id: string;
  amount: number;
  currency: string;
  status: string;
  description: string | null;
  paidAt: string | null;
  createdAt: string;
};

export function getTierInfo() {
  return get<TierInfo>("/internal/billing/tier-info");
}
export function getSubscription() {
  return get<SubscriptionDetails>("/internal/billing/subscription");
}
export function getPayments() {
  return get<PaymentRecord[]>("/internal/billing/payments");
}
export function getTestMode() {
  return get<{ testMode: boolean }>("/internal/billing/test-mode");
}
export function createCheckout(data: { tier: string; seats: number }) {
  return post<{ checkoutUrl: string }>("/internal/billing/checkout", data);
}
export function changeSubscription(data: { tier: string; seats: number }) {
  return post<{ success: boolean }>("/internal/billing/change", data);
}
export function cancelSubscription() {
  return post<{ success: boolean }>("/internal/billing/cancel");
}
export function resumeSubscription() {
  return post<{ success: boolean }>("/internal/billing/resume");
}
export function syncSubscription() {
  return post<SubscriptionDetails>("/internal/billing/sync");
}
export function updatePaymentMethod() {
  return post<{ checkoutUrl: string }>("/internal/billing/update-payment-method");
}
